import React, { useEffect, useState } from "react";
import { Button } from "@mui/material";
import RunScenarioInput from "./RunScenarioInput.jsx";
import { empty_uuid } from "./Account_urls.jsx";

const RunScenario = ({ clientJson, c_callback }) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const onSubmit = () => {
    handleShow();
  };

  useEffect(() => {
    console.log("RS");
    console.log(clientJson);
  }, [clientJson]);

  return (
    <>
      <Button
        variant="contained"
        size="small"
        disabled={clientJson.readonly ||
          clientJson.Scenario.readonly ||
          clientJson.uuid === empty_uuid}
        onClick={onSubmit}
      >
        Run Scenario
      </Button>
      <RunScenarioInput
        clientJson={clientJson}
        c_callback={c_callback}
        show={show}
        onClose={handleClose}
      />
    </>
  );
};

export default RunScenario;
